export { Ratings } from './Ratings'
export type { RatingsProps, RatingsTranslations } from './Ratings'
